import { MessageCircle, Phone } from "lucide-react";
import { IMAGES, PHONE_FIXED_TEL, PHONE_WHATSAPP, WA_MAIN } from "../constants/site";

export const Hero = () => (
    <section
        id="inicio"
        data-testid="hero-section"
        className="relative pt-12 pb-20 md:py-28 bg-white border-b border-neutral-200 overflow-hidden"
    >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-7 space-y-6">
                    <div
                        className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#ff6200]/10 border border-[#ff6200]/30 text-[#ff6200] text-xs font-semibold uppercase tracking-wider d1-fade"
                        style={{ animationDelay: "0.05s" }}
                    >
                        <span className="w-2 h-2 rounded-full bg-[#ff6200]" />
                        Rodovia Régis Bittencourt &bull; Miracatu e Região
                    </div>

                    <h1 className="display-type text-5xl sm:text-7xl lg:text-8xl font-black text-neutral-900 leading-[0.95] tracking-tight">
                        <span className="ln">
                            <span>PRECISA DE</span>
                        </span>
                        <span className="ln">
                            <span className="inline-block bg-[#ff6200] text-white px-4 sm:px-5 mt-2 -skew-x-6 shadow-lg">
                                GUINCHO?
                            </span>
                        </span>
                    </h1>

                    <p
                        className="text-lg text-neutral-600 max-w-xl d1-fade leading-relaxed"
                        style={{ animationDelay: "0.35s" }}
                    >
                        Serviço de guincho de plataforma com soluções personalizadas para
                        transportar seu veículo com segurança em Miracatu e região. Atendimento
                        profissional, transporte seguro e orçamento acessível.
                    </p>

                    <div className="flex flex-wrap gap-4 pt-2 d1-fade" style={{ animationDelay: "0.45s" }}>
                        <a
                            href={WA_MAIN}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="hero-whatsapp-btn"
                            className="bg-[#ff6200] hover:bg-[#e05600] text-white px-7 py-4 rounded font-bold text-sm uppercase tracking-wider transition-colors shadow-lg flex items-center gap-2"
                        >
                            <MessageCircle className="w-5 h-5" />
                            Chamar no WhatsApp: {PHONE_WHATSAPP}
                        </a>
                        <a
                            href={PHONE_FIXED_TEL}
                            data-testid="hero-call-btn"
                            className="border-2 border-neutral-900 hover:bg-neutral-900 hover:text-white text-neutral-900 px-6 py-4 rounded font-bold text-sm uppercase tracking-wider transition-colors flex items-center gap-2"
                        >
                            <Phone className="w-5 h-5" />
                            Ligar Agora
                        </a>
                    </div>

                    <div className="grid grid-cols-3 gap-4 pt-6 border-t border-neutral-200 text-xs text-neutral-600">
                        <div>
                            <span className="block font-bold text-neutral-900 text-sm">
                                Plataforma Asa-Delta
                            </span>
                            Carroceria inclinável
                        </div>
                        <div>
                            <span className="block font-bold text-neutral-900 text-sm">
                                Até 2 Veículos
                            </span>
                            Capacidade operacional
                        </div>
                        <div>
                            <span className="block font-bold text-neutral-900 text-sm">Sem Corrente</span>
                            Zero atrito no chassi
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-neutral-300 aspect-square d1-wipe bg-neutral-900">
                        <img
                            src={IMAGES.heroTruck}
                            alt="Caminhão guincho de plataforma da TMZ Guincho transportando SUV em Miracatu SP"
                            data-testid="hero-image"
                            loading="eager"
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
);
